import { Component } from "./component.js";
import { SubscriptionToggleUpdateEvent } from "./events.js";

/**
 * @class SubscriptionToggleComponent
 * @extends {Component}
 * @typedef {Object} Refs
 * @property {Element} toggleSwitch - The toggle switch element.
 * @description A component that toggles the subscription for a given event.
 */
class SubscriptionToggleComponent extends Component {
  /**
   * Toggles the subscription for the given event.
   * @param {Event} event - The event.
   */
  toggleSubscription(event) {
    if (event.target instanceof Element) {
      event.target.parentElement?.classList.toggle('active');
      this.#onSubscriptionToggleUpdate(event);
    }
  }

  /**
   * Handles the subscription toggle update event.
   * @param {Event} event - The event.
   */
  #onSubscriptionToggleUpdate(event) {
    const toggleSwitch = this;
    if (toggleSwitch instanceof Element) {
      let lineElement = toggleSwitch?.querySelector('input');
      let lineKey = lineElement?.getAttribute('data-toggle-line-item-key');
      let itemQuantity = lineElement?.getAttribute('data-item-quantity');
      let sellingPlanId = lineElement?.checked ? lineElement?.value : null;
      if (lineKey) {
        document?.dispatchEvent(new SubscriptionToggleUpdateEvent(Number(lineKey), sellingPlanId ? Number(sellingPlanId) : null, Number(itemQuantity)));
        setTimeout(() => {
          document.querySelector('cart-items-component')?.removeCartProperties(true);
        }, 2000);
      }
    }
  }
}

customElements.define('subscription-toggle-button', SubscriptionToggleComponent);